module.exports = __webpack_public_path__ + "img/mathsmith-full-color-rgb-logo-only.29c85fde.svg";